// extracted by css-extract-rspack-plugin
export default {"inert":"_459a6a78"};